import {
  AdditionalSupplyChainActorResponse,
  CreateOrUpdateAdditionalSupplyChainActorRequest,
} from '../../../../api/models'
import { AdditionalSupplyChainActor } from './schema'

export function toCreateOrUpdateAdditionalSupplyChainActorRequest(
  actor: AdditionalSupplyChainActor,
  index: number,
): CreateOrUpdateAdditionalSupplyChainActorRequest {
  return {
    id: actor.id,
    sequenceNumber: index,
    role: actor.role,
    identificationNumber: actor.identificationNumber,
  }
}

export function parseAdditionalSupplyChainActorResponse(
  response: AdditionalSupplyChainActorResponse,
  index: number,
): AdditionalSupplyChainActor {
  return {
    id: response.id,
    deleted: false,
    sequenceNumber: response?.sequenceNumber ?? index,
    identificationNumber: response?.identificationNumber ?? '',
    role: response?.role ?? '',
  }
}
